/**
 * The property name is shared by the plugin ID and the decoration `Range` property on
 * purpose: `getRenderLeaf` gates on `leaf[pluginID] != null`, and Slate merges a
 * decoration's properties onto the leaves it splits, so the two must match for the gate
 * to see the decoration.
 */
export const INSERTION_MARK_ID = 'insertionMarkId' as const;
export type InsertionMarkId = typeof INSERTION_MARK_ID;
